import React from 'react'
import { useTranslation } from 'react-i18next'
import { FallbackProps } from 'react-error-boundary'

import { ResidentAppError } from '../../../common/error'

import { Error } from 'components/Error'
import { ResidentAppErrorBoundary } from 'components/ResidentAppErrorBoundary/ResidentAppErrorBoundary'

interface QuestionErrorHandlerProps {
  children: React.ReactNode
}

export const QuestionErrorHandler: React.FC<QuestionErrorHandlerProps> = ({
  children,
}) => {
  const [t] = useTranslation(['question'])

  const fallbackRender = ({ error }: FallbackProps) => {
    if (error instanceof ResidentAppError) {
      switch (error.errorCode) {
        case 'QUESTION_MISSING_PHONE_NUMBER':
          return (
            <Error
              title={t('errors.missingUserPhoneNumber.title')}
              message={t('errors.missingUserPhoneNumber.message')}
            />
          )

        case 'QUESTION_SUBMIT_ERROR':
          return <Error message={t('errors.submitError')} />

        case 'NOT_FOUND':
          return <Error message={t('errors.noQuestionFound')} />

        default:
          return <Error message={t('errors.serviceUnavailable')} />
      }
    }

    return <Error message={t('errors.serviceUnavailable')} />
  }

  return (
    <ResidentAppErrorBoundary fallbackRender={fallbackRender}>
      {children}
    </ResidentAppErrorBoundary>
  )
}
